import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoLoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 118 48"
    {...props}
  >
    <g clipPath="url(#Logo_Loom_svg__a)">
      <path
        fill="#625DF5"
        d="M35.802 20.668h-10.72l9.283-5.331-1.84-3.174-9.284 5.332 5.358-9.234-3.19-1.832-5.359 9.232V5h-3.684v10.662l-5.36-9.233-3.19 1.832 5.359 9.232-9.282-5.33-1.842 3.174 9.283 5.331H.614v3.665h10.719L2.05 29.665l1.841 3.173 9.284-5.332-5.36 9.234 3.19 1.832 5.36-9.233V40h3.684V29.11l5.458 9.404 2.991-1.718-5.459-9.405 9.482 5.446 1.842-3.174-9.281-5.331H35.8v-3.664m-17.594 6.814a5.03 5.03 0 0 1-3.54-1.46A4.98 4.98 0 0 1 13.2 22.5a4.96 4.96 0 0 1 1.466-3.523 5 5 0 0 1 3.541-1.46 5.02 5.02 0 0 1 3.541 1.459 4.97 4.97 0 0 1 1.467 3.523 4.97 4.97 0 0 1-1.466 3.524 5.02 5.02 0 0 1-3.54 1.46"
      />
      <path
        fill="#212121"
        d="M45.298 35.302V9.698h4.723v25.604zm45.297-17.4h4.51v2.124c.959-1.698 3.197-2.618 5.114-2.618 2.38 0 4.297 1.026 5.185 2.899 1.383-2.124 3.231-2.9 5.54-2.9 3.231 0 6.32 1.945 6.32 6.613v11.282h-4.58V24.976c0-1.875-.924-3.29-3.091-3.29-2.025 0-3.232 1.557-3.232 3.432v10.185h-4.686V24.976c0-1.875-.959-3.29-3.09-3.29-2.06 0-3.268 1.522-3.268 3.432v10.185h-4.722zm-29.9 17.904c-5.322 0-9.175-3.928-9.175-9.204 0-5.192 3.842-9.212 9.174-9.212 5.358 0 9.174 4.058 9.174 9.212 0 5.238-3.855 9.204-9.174 9.204m0-14.158a5 5 0 0 0-3.519 1.454 4.95 4.95 0 0 0-1.458 3.501 4.95 4.95 0 0 0 1.458 3.502 5 5 0 0 0 3.518 1.453 5 5 0 0 0 3.517-1.454 4.95 4.95 0 0 0 1.458-3.5 4.95 4.95 0 0 0-1.458-3.502 5 5 0 0 0-3.517-1.454m19.26 14.158c-5.321 0-9.174-3.928-9.174-9.204 0-5.192 3.841-9.212 9.174-9.212 5.358 0 9.173 4.058 9.173 9.212 0 5.238-3.857 9.204-9.173 9.204m0-14.217a5.06 5.06 0 0 0-3.558 1.47 5 5 0 0 0-1.476 3.542 5 5 0 0 0 1.476 3.541 5.06 5.06 0 0 0 3.558 1.47 5.06 5.06 0 0 0 3.558-1.47 5 5 0 0 0 1.475-3.541 5 5 0 0 0-1.475-3.541 5.06 5.06 0 0 0-3.558-1.471"
      />
    </g>
    <defs>
      <clipPath id="Logo_Loom_svg__a">
        <path
          fill="#fff"
          d="M.615 0h117v48h-117z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoLoom;
